import {createFileRoute} from '@tanstack/react-router';
import ImageProtocols from '@/patient/views/imageProtocol/ImageProtocols';

export const Route = createFileRoute('/(patient)/patient/image-protocols')({
  component: ImageProtocols
});
